import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from 'angular-crumbs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NiceSelectModule } from 'ng-nice-select';
import { FormsModule } from '@angular/forms';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { GlobalModule } from '../../global/global.module';
import { ParagraphWysiwygComponent } from './paragraph-wysiwyg/paragraph-wysiwyg.component';

@NgModule({
  declarations: [
    ParagraphWysiwygComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    BreadcrumbModule,
    NiceSelectModule,
    FormsModule,
    SlickCarouselModule,
    GlobalModule,
  ],
  exports: [
    ParagraphWysiwygComponent
  ],
})
export class ParagraphsModule {}
